import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prjectMgm, auditBaseUrl } from '../endpoints';
// Define a service using a base URL and expected endpoints
  export const projectPhaseActivityService = createApi({
    reducerPath: 'projectPhaseActivityService',
    baseQuery: fetchBaseQuery({ baseUrl: auditBaseUrl }),
    tagTypes: ['ProjectPhaseActivity'],
    endpoints: (builder) => ({
        getAllProjectPhaseActivity: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.projectPhaseActivityController.getAllProjectPhaseActivity}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
        getProjectPhaseActivityById: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.projectPhaseActivityController.getProjectPhaseActivityById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
        saveProjectPhaseActivity: builder.mutation({
            query(body){
                return {
                    url: `${prjectMgm.projectPhaseActivityController.saveProjectPhaseActivity}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}`},
                    body: body.payload,
                }
            }
        }),
        updateProjectPhaseActivity: builder.mutation({
            query(body){
                return {
                    url: `${prjectMgm.projectPhaseActivityController.updateProjectPhaseActivity}/${body.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}`},
                    body: body.payload,
                }
            }
        }),
        deleteProjectPhaseActivity: builder.mutation({
            query(body){
                return {
                    url: `${prjectMgm.projectPhaseActivityController.deleteProjectPhaseActivity}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
        getAllProjectPhaseActivityWithSearch: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.projectPhaseActivityController.getAllProjectPhaseActivityWithSearch}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}`},
                    body: body.payload,
                };
            },
        }),
        findAllProjectPhaseActivity: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.projectPhaseActivityController.findAllProjectPhaseActivity}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
    })
  });
  export const {
    useGetAllProjectPhaseActivityMutation,
    useSaveProjectPhaseActivityMutation,
    useUpdateProjectPhaseActivityMutation,
    useDeleteProjectPhaseActivityMutation,
    useGetProjectPhaseActivityByIdMutation,
    useGetAllProjectPhaseActivityWithSearchMutation,
    useFindAllProjectPhaseActivityMutation,
  } = projectPhaseActivityService;